module.exports = __webpack_public_path__ + "img/btn_menu_certified.1530ff09.png";